import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  startFromLastInterval(event) {
    const lastInterval = event.target.dataset.lastinterval;
    $(event.target.dataset.target).val(lastInterval);
  }
}
